export default __webpack_public_path__ + "static/merch-e3626be2ff57a8865bb42bc2ab5dbc4c.jpg";